import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
import { VMenu } from 'vuetify/lib/components/VMenu';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    on: {
      click: _vm.shutCart
    }
  }, [_c("ScheduledMaintenanceAlert"), _c(VApp, [_c(VAppBar, {
    staticClass: "app-header",
    attrs: {
      height: "126px",
      "max-height": "126px",
      elevation: "0"
    }
  }, [_c("nav", {
    staticClass: "main-menu"
  }, [_c("div", {
    staticClass: "menu-logo-img --no-pointer"
  }), _c("div", {
    attrs: {
      id: "textual-menus"
    }
  }, [_c("div", {
    attrs: {
      id: "menu-home-brand"
    }
  }, [_vm._v(_vm._s(_vm.$whitelabel.brand))])])]), _c("div", {
    staticClass: "header-utils"
  }, [_c(VMenu, {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c("img", _vm._g({
          staticClass: "profile-img",
          attrs: {
            src: require("@/assets/images/icon_profil_white.svg"),
            alt: ""
          }
        }, on))];
      }
    }])
  }, [_c(VList, [_vm._l(_vm.menus, function (m) {
    return _c(VListItem, {
      key: m.id
    }, [_c(VListItemContent, [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.menuAction(m.route, m.tab)
      }
    }, [_c("span", {
      staticClass: "header-profile-menu-item"
    }, [_vm._v(_vm._s(m.label.toUpperCase()))]), m.route === "userProfile" && m.tab === "profile" && (_vm.isUserBuyerGroup(_vm.loggedUserData) || _vm.loggedUserData.isHolding) ? [_c("br"), _c("span", {
      staticClass: "text-italic text-capitalize"
    }, [_vm._v(_vm._s(m.status))])] : _vm._e()], 2)], 1)], 1);
  }), _c(VListItem, [_c(VListItemContent, [_c("span", {
    staticClass: "router-link",
    on: {
      click: function click($event) {
        return _vm.disconnectUser();
      }
    }
  }, [_c("span", {
    staticClass: "header-profile-menu-item"
  }, [_vm._v("SIGN OUT")])])])], 1)], 2)], 1), _vm.buyer ? _c("div", {
    staticClass: "cart-img",
    on: {
      click: _vm.showCart
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/icons/cart.svg"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "cart-img-label"
  }, [_vm._v(_vm._s(_vm.nbItems) + " item" + _vm._s(_vm.nbItems > 1 ? "s" : null))])]) : _vm._e()], 1)]), _c(VMain, {
    staticClass: "container-home"
  }, [_c(VContainer, {
    attrs: {
      fluid: ""
    }
  }, [_c("div", {
    attrs: {
      id: "content-menu-list"
    }
  }, _vm._l(_vm.menus_images, function (item, index) {
    return _c("div", {
      key: index,
      on: {
        click: function click($event) {
          return _vm.clickCardMenu(item.route_name);
        }
      }
    }, [_c("div", {
      staticClass: "content-menu-img-container"
    }, [_c("img", {
      attrs: {
        src: item.image,
        alt: ""
      }
    }), _c("div", {
      staticClass: "overlay",
      attrs: {
        id: item.route_name
      }
    }, [_vm._v(" " + _vm._s(item.description) + " ")])]), _c("div", {
      staticClass: "menu-label"
    }, [_c("label", [_vm._v(_vm._s(item.name))])])]);
  }), 0), _c("div", {
    on: {
      mouseenter: function mouseenter($event) {
        _vm.hoverCart = true;
      },
      mouseleave: function mouseleave($event) {
        _vm.hoverCart = false;
      }
    }
  }, [_c("cart", {
    staticClass: "cart",
    class: [_vm.cart ? "cart-shown" : "cart-hidden"],
    attrs: {
      loggedUserData: _vm.loggedUserData,
      transition: "expand"
    },
    on: {
      shutCart: _vm.shutCart
    }
  })], 1)])], 1), _c("footer-component", {
    attrs: {
      isTerms: true
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };